var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"title primary--text"},[_vm._v("Inspección:")]),_c('SinisterAppraisersList',{attrs:{"appraisers":_vm.sinister.appraisers_list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }